import { BANK_LOGO_CODES } from '../lib/banks'

// Logo do banco (SVG em public/banks/<código>.svg — reaproveitado do crm-twms).
// Fallback: círculo colorido com iniciais quando não há logo pro código.
function hueFrom(s: string) {
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 360
  return h
}

// Conta de dinheiro não tem banco nem código, então caía sempre no fallback de
// iniciais — a Caixinha aparecia como um quadrado "CA". Agora tem ícone próprio:
// o desenho que o dono mandou, vetorizado em public/banks/caixinha.svg.
// `type` é opcional; quem não tem o dado em mãos segue no comportamento antigo.
export function BankLogo({ code, name, type, size = 36 }: {
  code?: string | null; name?: string; type?: string | null; size?: number
}) {
  // O ?v=2 fura o cache envenenado: até 03/08/2026 o nginx servia public/ com
  // `immutable`, e quem carregou a 1ª versão do desenho não revalidava mais —
  // nem no F5. A política já foi corrigida em nginx.conf; este parâmetro é o
  // resgate de quem ficou preso. Trocando o desenho de novo, dá pra deixar como
  // está: daqui pra frente o ETag resolve sozinho.
  if (type === 'dinheiro') {
    return (
      <img
        src="/banks/caixinha.svg?v=2" alt={name || 'Caixinha'} width={size} height={size} loading="lazy"
        className="shrink-0" style={{ width: size, height: size }}
      />
    )
  }
  if (code && BANK_LOGO_CODES.has(code)) {
    return (
      <img
        src={`/banks/${code}.svg`} alt={name || ''} width={size} height={size} loading="lazy"
        className="shrink-0 rounded-md" style={{ width: size, height: size }}
      />
    )
  }
  const words = (name || '').replace(/[^0-9A-Za-zÀ-ú ]/g, ' ').trim().split(/\s+/).filter(Boolean)
  let initials = 'B'
  if (words.length) {
    if (/^[A-ZÀ-Ú0-9]{2,4}$/.test(words[0])) initials = words[0].slice(0, 2)
    else if (words.length >= 2) initials = (words[0][0] + words[1][0]).toUpperCase()
    else initials = words[0].slice(0, 2).toUpperCase()
  }
  const hue = hueFrom(name || code || 'banco')
  return (
    <div
      className="shrink-0 rounded-md flex items-center justify-center font-bold text-white"
      style={{ width: size, height: size, backgroundColor: `hsl(${hue} 52% 46%)`, fontSize: Math.round(size * 0.36) }}
    >
      {initials}
    </div>
  )
}
